/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Comment_LabelInputs */

const en_us2_engagement_comment_label = /** @type {(inputs: Engagement_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your comment (optional)`)
};

const pt_br2_engagement_comment_label = /** @type {(inputs: Engagement_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu comentário (opcional)`)
};

const es_419_engagement_comment_label = /** @type {(inputs: Engagement_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu comentario (opcional)`)
};

const pt_pt2_engagement_comment_label = /** @type {(inputs: Engagement_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu comentário (opcional)`)
};

const fr_fr2_engagement_comment_label = /** @type {(inputs: Engagement_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton commentaire (facultatif)`)
};

const de_de2_engagement_comment_label = /** @type {(inputs: Engagement_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Kommentar (optional)`)
};

const it_it2_engagement_comment_label = /** @type {(inputs: Engagement_Comment_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo commento (facoltativo)`)
};

/**
* | output |
* | --- |
* | "Your comment (optional)" |
*
* @param {Engagement_Comment_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_comment_label = /** @type {((inputs?: Engagement_Comment_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Comment_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_comment_label(inputs)
	if (locale === "es-419") return es_419_engagement_comment_label(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_comment_label(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_comment_label(inputs)
	if (locale === "de-DE") return de_de2_engagement_comment_label(inputs)
	if (locale === "it-IT") return it_it2_engagement_comment_label(inputs)
	return en_us2_engagement_comment_label(inputs)
});
export { engagement_comment_label as "engagement.comment_label" }